import { Box, Container, Grid, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import SectionHeader from "../components/SectionHeader";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function RegisterationTemp({ email }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [phoneNumber, setPhoneNumber] = useState("050-3818-8719");
  const displayLp = searchParams.get("display")
    ? searchParams.get("display")
    : undefined;
  const lpSource = searchParams.get("lpSource") ?? undefined;

  useEffect(() => {
    if (lpSource === "nec_121") {
      setPhoneNumber("050-3629-9702");
    } else if (lpSource === "nec_laviewiz") {
      setPhoneNumber("050-3629-9916");
    }
  }, [searchParams]);
  const registerationList = [
    {
      name: "登録情報入力",
      color: "grey",
    },
    {
      name: "メールを送信しました",
      color: "grey",
    },
    {
      name: "メールのご確認",
      color: "primary",
    },
    {
      name: "登録完了",
      color: "primary",
    },
  ];
  useEffect(() => {
    document.title = "会員仮登録完了 | じぶん専用IT相談室";
  }, []);
  const navigate = useNavigate();
  return (
    <Box
      component={"section"}
      className={displayLp != "lp" ? "section bg-dots" : "section"}
    >
      <Container className="container">
        <Box sx={{ textAlign: "center" }}>
          <SectionHeader
            currentPage={"まだ登録は<br/>完了していません"}
            preHeading={"Registration"}
          />
          <Typography
            component={"p"}
            style={{ maxWidth: "600px", margin: "0 auto" }}
            className="mobile-text-left"
          >
            ご登録いただいたアドレス宛に確認メールを送信しました。
            <br />
            <strong>
              本人確認のため、メール文中にある「認証用URL」をクリックすると登録が完了します。
            </strong>
            確認メールは「{email}」からお送りします。
            メールが届かない場合、迷惑メールフォルダに分類されていないかご確認の上、再度お試しください。
            それでも解決しない場合は「{phoneNumber}」までお電話ください。
          </Typography>
          {displayLp != "lp" && (
            <Box className="registeration-list-wrapper element-box">
              {registerationList.map((list, idx) => (
                <Grid container spacing={2} alignItems="center" key={idx}>
                  <Grid item>
                    <span className={`number-circle ${list.color}`}>
                      {idx + 1}
                    </span>
                  </Grid>
                  <Grid item>
                    <Typography
                      className={`color-${list.color} password-complete-text`}
                      component={"p"}
                    >
                      {list.name}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Box>
          )}
          <button
            className="classification-btn mt-2"
            onClick={() => navigate(-1)}
          >
            戻る
          </button>
        </Box>
      </Container>
    </Box>
  );
}
